module.exports = __webpack_public_path__ + "img/1500791553.2a8ea200.jpg";